var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pending)?_c('BaseLoadingBar',{attrs:{"is-small":""}}):_c('div',{staticClass:"content__choices"},[_c('selection-tree',{ref:"selectionTree",attrs:{"root":_vm.root},on:{"onchange":_vm.onchange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }